import useAttentionSignals from '../profile/useAttentionSignals';
import useProfileSummary from './rail/useProfileSummary';
import useMyRequests from './rail/useMyRequests';
import useProposalsToApprove from './rail/useProposalsToApprove';
import useToolRequests from './rail/useToolRequests';
import ProfileSummaryCard from './rail/ProfileSummaryCard';
import AttentionCard from './rail/AttentionCard';
import MyRequestsCard from './rail/MyRequestsCard';
import ToApproveCard from './rail/ToApproveCard';
import ToolsPanel from './tools/ToolsPanel';
// Avatar and CardState are styled in profile.css, which otherwise only
// ProfilePage imports; the bundler dedupes the second import.
import '../profile/profile.css';
import './home.css';

export default function HomePage() {
  const attention = useAttentionSignals();
  const summary = useProfileSummary();
  // One /api/tool_requests fetch shared by My requests and To approve.
  const proposals = useToolRequests();
  const requests = useMyRequests({ proposals });
  const approvals = useProposalsToApprove(proposals);

  return (
    // The shared user-page gutter (.main-content-inner), not .container: its
    // 16px gutter put Home's left edge 8px off every other page, and its
    // overflow-x:hidden made it a scroll container for the sticky rail.
    <div className="main-content-inner page-fill home">
      <div className="home-grid">
        <aside className="home-rail" aria-label="Your profile and requests">
          <ProfileSummaryCard summary={summary} completeness={attention.completeness} completenessLoading={attention.loading} />
          <AttentionCard items={attention.items} loading={attention.loading} />
          <MyRequestsCard requests={requests} />
          <ToApproveCard rows={approvals.rows} />
        </aside>
        <ToolsPanel />
      </div>
    </div>
  );
}
